import { ExternalLinkType } from '@inpart-io/padme-iap';

import { ICONS_NAME } from '@/constants/ui/icons.constants';
import { i18nService } from '@/services/i18n-service';

export const ExternalLinkTypeIcon = new Map<string, string>([
    [ExternalLinkType.DEFAULT, ICONS_NAME.LINKED],
    [ExternalLinkType.GOOGLE_DRIVE, ICONS_NAME.GOOGLE_DRIVE],
    [ExternalLinkType.SHAREPOINT, ICONS_NAME.SHAREPOINT],
    [ExternalLinkType.YOUTUBE, ICONS_NAME.YOUTUBE]
]);

export const ExternalLinkTypeLabel = new Map<string, string>([
    [ExternalLinkType.DEFAULT, i18nService.t(`EXTERNAL_LINK_TYPES.${ExternalLinkType.DEFAULT}`).toString()],
    [ExternalLinkType.GOOGLE_DRIVE, i18nService.t(`EXTERNAL_LINK_TYPES.${ExternalLinkType.GOOGLE_DRIVE}`).toString()],
    [ExternalLinkType.SHAREPOINT, i18nService.t(`EXTERNAL_LINK_TYPES.${ExternalLinkType.SHAREPOINT}`).toString()],
    [ExternalLinkType.YOUTUBE, i18nService.t(`EXTERNAL_LINK_TYPES.${ExternalLinkType.YOUTUBE}`).toString()]
]);
